import { FC } from "react";

interface ISettings {}

const SettingsPage: FC<ISettings> = () => {
  return <div>SettingsPage</div>;
};

export default SettingsPage;
